import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from ".";

export interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  claims?: Record<string, unknown>;
}

type UserProfile = Record<string, unknown>;

export const appSlice = createSlice({
  name: "app",
  initialState: {
    isLoading: false,
    isApiLoading: false,
    apiRequestCount: 0,
    user: null as User | null,
    profile: null as UserProfile | null,
    showHeader: true,
    showFooter: true,
    showBanner: false,
  },
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setProfile: (state, action: PayloadAction<UserProfile | null>) => {
      state.profile = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsApiLoading: (state, action: PayloadAction<boolean>) => {
      const isStarting = Boolean(action.payload);

      if (isStarting) {
        state.apiRequestCount += 1;
      } else {
        state.apiRequestCount = Math.max(0, state.apiRequestCount - 1);
      }

      state.isApiLoading = state.apiRequestCount > 0;
    },
    resetApiLoading: (state) => {
      state.apiRequestCount = 0;
      state.isApiLoading = false;
    },
  },
});

export const { setUser, setProfile, setIsLoading, setIsApiLoading, resetApiLoading } =
  appSlice.actions;

export const currentUser = (state: RootState) => state.app.user;
export const getProfile = (state: RootState) => state.app.profile;
export const getIsLoading = (state: RootState) => state.app.isLoading;
export const getIsApiLoading = (state: RootState) => state.app.isApiLoading;
export const getApiRequestCount = (state: RootState) => state.app.apiRequestCount;

export default appSlice.reducer;
